import { useQuery } from "@tanstack/react-query";
import TerminalService from "../../app/data/terminal-details/terminalService";

const TERMINAL_DETAILS_QUERY_KEY = "terminalDetailsByNumber";

export interface TerminalDetailsContact {
  managerName?: string | null;
  managerPhone?: string | null;
  managerEmail?: string | null;
  phoneNumber?: string | null;
  terminalEmail?: string | null;
}

export interface TerminalDetailsAddress {
  physicalAddress?: string | null;
  city?: string | null;
  stateProvince?: string | null;
  zipPostalCode?: string | null;
  country?: string | null;
}

export interface TerminalDetailsRegion {
  regionName?: string | null;
}

export interface TerminalDetailsTerminalType {
  type?: string | null;
  description?: string | null;
}

export interface TerminalDetailsResult {
  terminalNumber?: number | null;
  terminalName?: string | null;
  airportCode?: string | null;
  status?: string | null;
  division?: string | null;
  timezone?: string | null;
  warehouse?: boolean | null;
  terminalType?: TerminalDetailsTerminalType | null;
  address?: TerminalDetailsAddress | null;
  contact?: TerminalDetailsContact | null;
  region?: TerminalDetailsRegion | null;
}

export function useTerminalDetails(
  terminalNumber: number | undefined,
  enabled: boolean = true
) {
  const isValid = typeof terminalNumber === "number" && Number.isFinite(terminalNumber);

  return useQuery<TerminalDetailsResult | null>({
    queryKey: [TERMINAL_DETAILS_QUERY_KEY, terminalNumber],
    enabled: enabled && isValid,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await TerminalService.getInstance().getTerminalSummaryByTerminalNumber(
        String(terminalNumber)
      );
      if (!res?.ok?.()) return null;
      return (res.data ?? null) as TerminalDetailsResult | null;
    },
  });
}
